import { Card, CardContent } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";

export default function ProductCardSkeleton() {
  return (
    <Card className="overflow-hidden border border-gray-100 dark:border-gray-800 rounded-xl shadow-xs bg-white/70 dark:bg-[#1a1a1a]/70 backdrop-blur-sm">
      <CardContent className="p-0 relative">
        {/* Image Skeleton */}
        <Skeleton className="w-full h-48" />

        {/* Content Skeleton */}
        <div className="p-4">
          {/* Rating Skeleton */}
          <div className="flex items-center gap-1 mb-2">
            <Skeleton className="w-16 h-4" />
            <Skeleton className="w-12 h-4 ml-2" />
          </div>

          {/* Title Skeleton */}
          <Skeleton className="w-3/4 h-5 mb-2" />

          {/* Description Skeleton */}
          <div className="mb-3 space-y-1">
            <Skeleton className="w-full h-4" />
            <Skeleton className="w-5/6 h-4" />
          </div>

          {/* Price and Button Skeleton */}
          <div className="flex items-center justify-between">
            <Skeleton className="w-24 h-6" />
            <Skeleton className="w-24 h-10 rounded-md" />
          </div>
        </div>
      </CardContent>
    </Card>
  );
}

